import type { GroupCollapseState } from 'pages/Project/UerProject/ActKC3List/components/ActKC3ListTable/types';
import type { IContractOtherCostLimitSpanSelectionItem } from 'pages/Project/UerProject/Contract/hooks/useUerContractOtherCostLimitSpanSelectionList';
import { Button, IconArrowDown, IconArrowRight } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import { useMemo } from 'react';
import type React from 'react';

interface INameCellRendererComponent extends ICellRendererParams<IContractOtherCostLimitSpanSelectionItem> {
    changeCollapseState: (groupKey: string) => () => void;
    collapseState: GroupCollapseState;
}

export const NameCellRendererComponent: React.FC<INameCellRendererComponent> = (props) => {
    const { data, collapseState, changeCollapseState } = props;

    const areChildrenShown = useMemo(
        () => !(data?.groupKey && collapseState?.[data?.groupKey]),
        [collapseState, data?.groupKey],
    );

    return (
        <div>
            {!!data?.isGroup && (
                <Button
                    size="xs"
                    view="clear"
                    onlyIcon
                    iconRight={areChildrenShown ? IconArrowDown : IconArrowRight}
                    onClick={data?.isGroup && data?.groupKey ? changeCollapseState?.(data?.groupKey) : undefined}
                    style={{ marginRight: 8, width: 16 }}
                />
            )}
            {data?.name}
        </div>
    );
};

NameCellRendererComponent.displayName = 'NameCellRendererComponent';
